module.exports = __webpack_public_path__ + "img/logo-alchemy.e80ac540.jpg";